import { useState, useEffect } from "react";
import { timeAgo, formatTime } from "./utils";
import { IcWarning, IcClock, IcMemo } from "./Icons";

export default function OrderCard({ order, onStatusChange, onCancel, isNew, isAlarm }) {
  const [updating, setUpdating] = useState(false);
  const [elapsed, setElapsed] = useState(timeAgo(order.created_at));

  useEffect(() => {
    const timer = setInterval(() => {
      setElapsed(timeAgo(order.created_at));
    }, 10000);
    return () => clearInterval(timer);
  }, [order.created_at]);

  const handleStatus = async (newStatus) => {
    setUpdating(true);
    await onStatusChange(order.id, newStatus);
    setUpdating(false);
  };

  const urgentMinutes = Math.floor(
    (Date.now() - new Date(order.created_at.replace(" ", "T") + "Z").getTime()) / 60000
  );
  const isUrgent = urgentMinutes >= 8;

  // Card click → primary action (complete the order)
  const handleCardClick = () => {
    if (!updating) handleStatus("DONE");
  };

  return (
    <div
      className={`order-card${isNew ? " is-new" : ""}${isAlarm ? " is-alarm" : ""}${
        order.status === "PREPARING" ? " is-preparing" : ""
      }${isUrgent ? " is-urgent" : ""}`}
      onClick={handleCardClick}
    >
      <div className="card-header">
        <div className="card-left">
          <span className="table-name">{order.table_label}</span>
          <span className="order-id">#{order.id}</span>
        </div>
        <div className="card-right">
          <span className={`elapsed${isUrgent ? " urgent" : ""}`} style={{display:"inline-flex",alignItems:"center",gap:5}}>
            {isUrgent ? <IcWarning size={12} /> : <IcClock size={12} />}
            {elapsed}
          </span>
          <span className="order-time">{formatTime(order.created_at)}</span>
        </div>
      </div>

      <div className="items-list">
        {order.items && order.items.length > 0 ? (
          order.items.map((item) => (
            <div key={item.id} className="item-row">
              {item.weight_grams
                ? <span className="item-weight-badge">{item.weight_grams}g</span>
                : <span className="item-qty">{item.quantity}×</span>}
              <span className="item-name">{item.product_name}</span>
              {item.item_note && (
                <span className="item-note">({item.item_note})</span>
              )}
            </div>
          ))
        ) : (
          <div className="item-row no-items">—</div>
        )}
      </div>

      {order.note && (
        <div className="order-note">
          <span className="note-icon"><IcMemo size={13} /></span> {order.note}
        </div>
      )}

      <div className="card-footer">
        <span className="total-amount">₺{order.total_amount?.toLocaleString("tr-TR")}</span>
        <div className="action-btns">
          {order.status === "OPEN" && (
            <>
              <button
                className="btn btn-preparing"
                onClick={(e) => { e.stopPropagation(); handleStatus("PREPARING"); }}
                disabled={updating}
              >
                Hazırlanıyor
              </button>
              <button
                className="btn btn-done"
                onClick={(e) => { e.stopPropagation(); handleStatus("DONE"); }}
                disabled={updating}
              >
                ✓ Tamamla
              </button>
            </>
          )}
          {order.status === "PREPARING" && (
            <button
              className="btn btn-done"
              onClick={(e) => { e.stopPropagation(); handleStatus("DONE"); }}
              disabled={updating}
            >
              ✓ Teslim Et
            </button>
          )}
          {onCancel && (order.status === "OPEN" || order.status === "PREPARING") && (
            <button
              className="btn btn-cancel-order"
              title="Siparişi İptal Et"
              onClick={(e) => { e.stopPropagation(); onCancel(order.id); }}
              disabled={updating}
            >
              ✕
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
